<div class="mb-2 flex items-center justify-between">
  <h1 class="main-title">Gestión de turnos > Novedades Diarias Jefe de Turno</h1>
  <div>
    <button
      class="button button-outlined-primary button-sm mr-3"
      (click)="openPdfPreview()">
      Previsualización
    </button>
    <button class="button button-outlined-secondary button-sm mr-3" (click)="openConfirmPopup()">
      Abrir turno diario
    </button>
    <button class="button button-warning button-sm" (click)="shiftClosure()">
      Cierre de turno diario
    </button>
  </div>
</div>

<div class="box mb-4">
  <h2 class="main-subtitle">Seguridad / Calidad / Medio Ambiente:</h2>
  <app-table
    class="table-news table-switch"
    [columns]="shiftUpdatesTableColumns"
    [data]="seguridadCalidadMedioAmbiente"
    [tableType]="'seguridad'"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="">
        </button>
        <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="">
        </button>
      </div>
    </ng-template>
  </app-table>

  <h2 class="main-subtitle mt-6">Personal (Ausentismo, Licencias Médicas):</h2>
  <app-table
    class="table-news table-switch"
    [columns]="shiftUpdatesTablePersonalColumns"
    [data]="personalData"
    [tableType]="'personal'"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="">
        </button>
        <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="">
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<div class="box">
  <!-- Iterar sobre cada área y crear una tabla para cada una -->
  <div *ngFor="let areaName of areaNames" class="mb-6">
    <h2 class="main-subtitle">{{ areaName }}</h2>
    <app-table
      class="table-news table-switch"
      [columns]="generalTableColumns"
      [data]="groupedGeneralData[areaName]"
      [tableType]="areaName"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
      (selectAllChange)="onSelectAllChange($event)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)" title="Ver">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <!-- <button (click)="openCloneConfirmation(visation)" title="Clonar">
            <img src="assets/icons/copy-icon.svg" alt="">
          </button> -->
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="">
          </button>
          <!-- 
          <button *ngIf="visation.isCloned" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="">
          </button> -->
        </div>
      </ng-template>
    </app-table>
  </div>

  <h2 class="main-subtitle">Aviso de averías solicitado</h2>
  <app-table
    class="table-news table-switch"
    [columns]="reportedBreakdownNoticeTableColumns"
    [data]="flattenedData['aviso_averias']"
    [tableType]="'aviso_averias'"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <!-- <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="">
        </button> -->
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="">
        </button>
        <!--
        <button *ngIf="visation.isCloned" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="">
        </button> -->
      </div>
    </ng-template>
  </app-table>
</div>

<!-- 

<div class="pb-16">
  <h2 class="main-subtitle">Orden de Trabajo</h2>
  <app-table
    class="table-news table-switch"
    [columns]="workOrderTableColumns"
    [data]="flattenedData['o_t_ejecutadas']"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>

      </div>
    </ng-template>
  </app-table>
</div>

<div class="pb-16">
  <h2 class="main-subtitle">Fuera de servicios</h2>
  <app-table
    class="table-news table-switch"
    [columns]="outOfServiceTableColumns"
    [data]="flattenedData['fuera_servicio']"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>

      </div>
    </ng-template>
  </app-table>
</div>
-->
<app-confirm-popup
  *ngIf="showClonePopup"
  [message]="'¿Está seguro que deseas copiar esta novedad?'"
  (onConfirm)="confirmClone()"
  (onCancel)="closeClonePopup()"
></app-confirm-popup>

<app-confirm-popup
  *ngIf="showConfirmPopup"
  [message]="'¿Estás seguro que deseas iniciar un nuevo turno?'"
  (onConfirm)="confirmStartShift()"
  (onCancel)="closeConfirmPopup()"
></app-confirm-popup>
